<template>
  <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
    <com-header/>
    <div class="page-box-scroll">
      <div class="brand-list-details">
        <div class="brand-list-item" v-for="item in imgList">
          <el-image
            :src="item"
            :preview-src-list="imgList">
          </el-image>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "brand",
  data() {
    return {
      navDrawer: false,
      imgList: [],
      imgBg: ''
    }
  },
  mounted() {
    this.getImgBg({id: ''})
    if (this.$route.query.sourceType) {
      this.getAllImage({id: this.$route.query.id})
    }else {
      this.getImgList({id: this.$route.query.id})
    }
  },
  methods: {
    getAllImage(params) {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass: 'el-loading-com'
      });
      this.$get('/pc/shop/categoryPhotoCustomerSkipChlidList', params).then((res) => {
        loading.close();
        this.imgList = res.data
      }).catch((error) => {
        loading.close();
      })
    },
    getImgBg(params) {
      this.$get('/pc/shop/bgimg', params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getHandleImg(data) {
      if (data.length > 0) {
        let arr = data.map((item) => {
          return item = item.img
        })
        return arr
      }
      return []
    },
    getImgList(params) {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass: 'el-loading-com'
      });
      this.$get('/pc/shop/categoryPhotoCustomer', params).then((res) => {
        loading.close();
        this.imgList = res.data
      }).catch((error) => {
        loading.close();
      })
    },

  }

}
</script>

<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}

.brand-list-details {
  display: flex;
  flex-wrap: wrap;
  width: calc(100vw - 160px);
  margin: 40px 80px;
  box-sizing: border-box;
}

.brand-list-item {
  width: calc(25vw - 55px);
  //height:12.45vw;
  margin: 0 20px 20px 0;
  box-sizing: border-box;
  border-radius: 4px;

  .el-image {
    width: calc(25vw - 55px);
    //height:12.45vw;
    > img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
  }

}

.brand-list-item:nth-child(4n) {
  margin-right: 0;
}

.brand-list-item:hover {
  transform: scale(1.02);
  transition: all 0.3s;
}

</style>



// WEBPACK FOOTER //
// src/views/brandDetails.vue